import { createErrorHandler } from '../base';
import { aaCheckoutExceptionConfig } from './error-config';
import i18n from '@/helper/i18n';

const t = i18n.chain;

export { aaCheckoutExceptionConfig };
export const handleAACheckoutException = createErrorHandler(
  aaCheckoutExceptionConfig,
);
